import React from 'react'

import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'

import * as firebase from 'firebase'

import loginScreenContainer from './loginScreenContainer'

class TokenLogin extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      resetPassword: false
    }
  }

  onClick() {
    firebase.auth().signInWithCustomToken(this.token)
      .catch(error => alert(error.message))
  }

  render() {
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ marginTop: 60 }}>
          <div>
            <TextField
              floatingLabelFocusStyle={{ color: '#f00'}}
              floatingLabelStyle={{ color: '#f00'}}
              underlineFocusStyle={{ borderColor: '#527da3'}}
              floatingLabelText="Token"
              onChange={(event) => {this.token = event.target.value}}
              onKeyDown={event => {
                if (event.keyCode === 13) {
                  this.onClick()
                }
              }}/>
          </div>

          <div>
            <RaisedButton
              style={{ marginTop: 30 }}
              label={'Token Login'}
              labelColor="white"
              backgroundColor="#527da3"
              onTouchTap={this.onClick.bind(this)} />
          </div>
        </div>
      </div>
    )
  }
}

export default loginScreenContainer(TokenLogin)



// WEBPACK FOOTER //
// ./src/login/TokenLogin.js